const initialState = {
  pertanyaan: [],
  variablesurvey: null,
  rekapkuisioner: [],
  statusUser: false,
};

const surveyReducer = (state = initialState, action) => {
  let { type, data } = action;

  switch (type) {
    case "SET_PERTANYAAN":
      return {
        ...state,
        pertanyaan: data,
      };
    case "SET_VARIABLESURVEY":
      return {
        ...state,
        variablesurvey: data,
      };
    case "SET_REKAPSURVEY":
      return {
        ...state,
        rekapkuisioner: data,
      };
    case "SET_STATUS":
      return {
        ...state,
        statusUser: data,
      };
    default:
      return state;
  }
};

export default surveyReducer;
